(ns web3.external-utils
  (:require [web3.queries.root :as q-root]))

(defn ^:export get-user-id
  []
  (-> (q-root/me) :me :id))

(defn ^:export dump-app-db
  []
  (clj->js @re-frame.db/app-db))